<div class="section">
    <swiper-container *ngIf="scanners.length > 0">
        <swiper-slide *ngFor="let scanner of scanners">
            <template-qr-view
                    [showCopy]="false"
                    [scanner]="scanner"
                    [showEditButton]="true"
                    (deleted)="fetchScanner()"></template-qr-view>
        </swiper-slide>
    </swiper-container>
</div>
